import React, { useState } from "react";

import { ContentLayout, SpaceBetween, Tabs, Alert } from "@amzn/awsui-components-console";

import { useAppSelector } from "src/redux/hooks";
import type { RootState } from "src/redux/store";
import { Role } from "src/auth/types/interfaces";
import SimLinkGenerator from "src/components/simLinkGenerator/SimLinkGenerator";
import { SIM_TYPES } from "src/components/simLinkGenerator/types";
import MedicalPanelData from "./MedicalPanelData";
import MedicalAuthorizationDocuments from "./MedicalAuthorizationDocuments";
import Stateforms from "./StateForms";
import ProvinceForms from "./ProvinceForms";

const WorkersCompensationDocuments = () => {
  const roles = useAppSelector((state: RootState) => state.auth.user.roles);

  const showUsTab = roles.includes(Role.WC_CLAIM_USER);
  const showCanadaTab = roles.includes(Role.WC_CLAIM_CANADA_USER);

  const defaultActiveTab = showUsTab ? "us" : "canada";
  const [activeTabId, setActiveTabId] = useState(defaultActiveTab);

  if (!showUsTab && !showCanadaTab) {
    return (
      <ContentLayout>
        <Alert type="error" data-testid="no-access-alert">
          You do not have access to the Workers&apos; Compensation Documents Hub. Please open a{" "}
          <SimLinkGenerator
            simType={SIM_TYPES.REPORT_A_BUG}
            target="_blank"
            ariaLabel="Pressing this link will open a new tab where you will be able to create a support ticket."
          >
            support ticket
          </SimLinkGenerator>{" "}
          to contact support.
        </Alert>
      </ContentLayout>
    );
  }

  const tabs = [];

  if (showUsTab) {
    tabs.push({
      id: "us",
      label: "United States",
      content: (
        <SpaceBetween direction="vertical" size="m">
          <MedicalPanelData />
          <MedicalAuthorizationDocuments />
          <Stateforms />
        </SpaceBetween>
      ),
    });
  }

  if (showCanadaTab) {
    tabs.push({
      id: "canada",
      label: "Canada",
      content: <ProvinceForms />,
    });
  }

  return (
    <ContentLayout>
      <Tabs
        tabs={tabs}
        activeTabId={activeTabId}
        onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
        data-testid="documents-hub-tabs"
      />
    </ContentLayout>
  );
};

export default WorkersCompensationDocuments;
